import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-policy',
  templateUrl: './customer-policy.component.html',
  styleUrls: ['./customer-policy.component.css']
})
export class CustomerPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
